import React from "react";

const PaginationSplitter = () => <div className="admissions-pagination-splitter">...</div>

export default PaginationSplitter
